@import '../../../theme.scss';

verdocs-preview {
  font-family: $verdocs-primary-font;
  display: flex;
  padding: 15px;
  row-gap: 15px;
  min-height: 200px;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;

  div,
  canvas {
    box-sizing: border-box;
  }
}
